import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgLightbulbIconSecondary from './svgs/LightbulbIconSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var lightbulbIcon = (props => useIcon(null, SvgLightbulbIconSecondary, props));

export { lightbulbIcon as default };
